<template>
  <v-dialog max-width="600" v-model="show" persistent>
    <AuthorizerEdit
      v-model="enable_authorizer_edit_dialog"
      :editable="editable"
      :authorizerProp="authorizer_to_edit"
      :weighted="weighted"
      v-on:authorizer-update="handleAuthorizerUpdate"
      :authorizers="authorizers"
    ></AuthorizerEdit>
    <AuthorizerCreate
      v-model="enable_authorizer_create_dialog"
      :weighted="weighted"
      v-on:authorizer-store="handleAuthorizerStore"
      :authorizers="authorizers"
    ></AuthorizerCreate>
    <v-card>
      <v-card-title
        ><span class="title">{{ $t('fields.authorizers') }}</span></v-card-title
      >
      <v-card-text>
        <v-list two-line>
          <v-list-tile
            v-for="authorizer in authorizers"
            :key="authorizer.id"
            avatar
            @click.stop="openAuthorizerEditDialog(authorizer)"
          >
            <v-list-tile-content>
              <v-list-tile-title class="break-all">{{
                authorizer.name
              }}</v-list-tile-title>
              <v-list-tile-sub-title v-if="weighted">{{
                $t('fields.weight') + ': ' + authorizer.weight
              }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action v-if="editable">
              <v-btn
                icon
                ripple
                @click.stop="openAuthorizerEditDialog(authorizer)"
              >
                <v-icon small color="grey lighten-1">fa-edit</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-action v-if="editable">
              <v-btn
                icon
                ripple
                @click.stop="handleAuthorizerDestroy(authorizer)"
              >
                <v-icon small color="grey lighten-1">fa-trash</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-btn
          @click.stop="openAuthorizerCreateDialog()"
          class="ml-0"
          color="primary"
          slot="activator"
          small
          v-if="editable"
        >
          <v-icon small>fa-plus fa-fw</v-icon>
          Dodaj opunomoćitelja
        </v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" color="error">{{
          editable ? $t('buttons.cancel') : $t('buttons.close')
        }}</v-btn>
        <v-btn v-if="editable" @click="save" color="success">{{
          $t('buttons.save')
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AuthorizerEdit from '@/components/AuthorizerEdit.vue'
import AuthorizerCreate from '@/components/AuthorizerCreate.vue'
import { v4 as uuidv4 } from 'uuid'
import get_index_by_id from '@/helpers/get_index_by_id.js'
import Authorizer from '@/models/Authorizer.js'

export default {
  components: {
    AuthorizerEdit,
    AuthorizerCreate,
  },

  props: {
    editable: Boolean,
    value: Boolean,
    weighted: Boolean,
    voter: Object,
  },

  data: () => ({
    enable_authorizer_edit_dialog: false,
    enable_authorizer_create_dialog: false,
    authorizer_to_edit: null,
    authorizers_local: [],
  }),

  watch: {
    'voter.authorizers': {
      handler: function (newValue) {
        const newVoterAuthorizers =
          newValue === null || newValue === undefined
            ? []
            : Array.from(newValue.map(authorizer => new Authorizer(authorizer)))

        this.authorizers_local = newVoterAuthorizers
      },
      deep: true,
    },
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },

    authorizers() {
      const sortBy = 'name'

      if (this.voter === null) {
        return []
      }

      // Maps "extended" properties to instance of class Authorizer.
      return [...this.authorizers_local].sort((a, b) => {
        // Orders authorizers by name.
        return a[sortBy] < b[sortBy] ? -1 : a[sortBy] > b[sortBy] ? 1 : 0
      })
    },
  },

  methods: {
    close() {
      this.show = false

      this.authorizers_local = this.voter.authorizers
    },

    save() {
      this.$emit('updated', this.authorizers_local)

      this.close()
    },

    handleAuthorizerDestroy(authorizer) {
      const index = get_index_by_id(this.authorizers_local, authorizer.id)

      this.authorizers_local.splice(index, 1)
    },

    handleAuthorizerUpdate(authorizer) {
      const index = get_index_by_id(this.authorizers_local, authorizer.id)

      this.authorizers_local.splice(index, 1, authorizer)
    },

    handleAuthorizerStore(authorizer) {
      authorizer.id = uuidv4()

      this.authorizers_local.push(authorizer)
    },

    openAuthorizerEditDialog(authorizer) {
      this.authorizer_to_edit = new Authorizer(authorizer)
      this.enable_authorizer_edit_dialog = true
    },

    openAuthorizerCreateDialog() {
      this.enable_authorizer_create_dialog = true
    },
  },
}
</script>

<style scoped>
/* Sets list item height to auto, and applies padding for better fitment. */
::v-deep .v-list--three-line .v-list__tile {
  height: auto !important;
  padding: 8px 16px;
  min-height: 88px;
}

/* Sets list item title height to auto and wraps the title. */
::v-deep .v-list--three-line .v-list__tile__title {
  white-space: normal;
  height: auto;
  min-height: 24px;
}
</style>
